
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/headless-cms/comparison/[slug]",
      function () {
        return require("private-next-pages/headless-cms/comparison/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/headless-cms/comparison/[slug]"])
      });
    }
  